(() => {
  let t = (e) => {
      if (e && e.classList.contains("shopify-section-header")) {
        let t = e.querySelector("details-modal.header__search");
        e &&
          t &&
          e.addEventListener("keydown", (e) => {
            "Escape" === e.code && t.isOpen() && t.close();
          });
      }
    },
    e = document.currentScript.parentElement;
  document.addEventListener("DOMContentLoaded", function () {
    t(e);
  }),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target);
    });
})();
